module.exports = __webpack_public_path__ + "img/IMG_2729_L_Foamcore.8678b6e0.jpg";